import React, { useMemo, useState, useEffect } from 'react';
import CabecalhoShared from '@alweb-merkator/shared/components/CabecalhoFeiras';
import LogoImagePt from '../../assets/logo-sicc-pt-br.png';
import LogoImageEs from '../../assets/logo-sicc-es-br.png';
import LogoImageEn from '../../assets/logo-sicc-us-br.png';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

const Cabecalho = () => {
  const { t } = useTranslation();
  const { lang } = useParams();

  const [logoImage, setLogoImage] = useState();

  function setLogoLanguage() {
    switch (lang) {
      case 'es':
        setLogoImage(LogoImageEs);
        break;
      case 'en':
        setLogoImage(LogoImageEn);
        break;
      default:
        setLogoImage(LogoImagePt);
    }
  }

  useEffect(() => {
    setLogoLanguage();
  }, []);

  const medias = [
    {
      socialMedia: 'tiktok',
      link: '//www.tiktok.com/@siccgramado',
    },
    {
      socialMedia: 'facebook',
      link: '//www.facebook.com/siccgramado',
    },
    {
      socialMedia: 'instagram',
      link: '//www.instagram.com/siccgramado',
    },
    {
      socialMedia: 'apple',
      link: '//apps.apple.com/us/app/merkator-feiras-e-eventos/id1487335018',
    },
    {
      socialMedia: 'googlePlay',
      link: '//play.google.com/store/apps/details?id=com.merkatorvisitante&hl=pt_BR&gl=US',
    },
    {
      socialMedia: 'linkedin',
      link: '//www.linkedin.com/showcase/siccgramado',
    },
  ];

  const menuItem = (text, link, subMenus = [], externalLink = false) => ({
    text: text,
    link: link,
    subMenus,
    externalLink,
  });

  const menu = useMemo(() => {
    const myMenu = [
      menuItem(t('cabecalho.sobreAFeira'), `/${lang}#${t('slugs.sicc')}`, [
        menuItem(t('cabecalho.sicc'), `/${lang}#${t('slugs.sicc')}`),
        menuItem(t('cabecalho.gramado'), `/${lang}#${t('slugs.gramado')}`),
        menuItem(t('cabecalho.serraPark'), `/${lang}#${t('slugs.serraPark')}`),
        menuItem(t('cabecalho.parceiros'), `/${lang}#${t('slugs.parceiros')}`),
        menuItem(
          t('cabecalho.grupoDeImportadores'),
          `/${lang}#${t('slugs.grupoDeImportadores')}`
        ),
        menuItem(t('cabecalho.estacao3'), `/${lang}#${t('slugs.estacao3')}`),
        menuItem(t('cabecalho.onnoPlace'), `/${lang}#${t('slugs.onnoPlace')}`),
      ]),
      menuItem(
        t('cabecalho.queroVisitar'),
        `/${lang}#${t('slugs.queroVisitar')}`,
        [
          menuItem(
            t('cabecalho.hospedagem'),
            `/${lang}#${t('slugs.queroVisitar')}`
          ),

          menuItem(
            t('cabecalho.traslado'),
            `/${lang}#${t('slugs.queroVisitar')}`
          ),

          menuItem(
            t('cabecalho.credenciamento'),
            `/${lang}#${t('slugs.queroVisitar')}`
          ),

          menuItem(
            t('cabecalho.agenciaDeTurismo'),
            `/${lang}/#${t('slugs.agenciaDeTurismo')}`
          ),

          menuItem(
            t('cabecalho.expositores'),
            `/${lang}/#${t('slugs.expositores')}`
          ),

          menuItem(
            t('cabecalho.plantaBaixa'),
            `/${lang}/#${t('slugs.plantaBaixa')}`
          ),
        ]
      ),
      menuItem(t('cabecalho.eMerkator'), `/${lang}#${t('slugs.eMerkator')}`, [
        menuItem(
          t('cabecalho.eMerkatorTalks'),
          `/${lang}/#${t('slugs.eMerkator')}`
        ),
        menuItem(
          t('cabecalho.eMerkatorBlog'),
          `/${lang}/#${t('slugs.eMerkator')}`
        ),
        menuItem(
          t('cabecalho.eMerkatorTV'),
          `/${lang}/#${t('slugs.eMerkator')}`
        ),
        menuItem(
          t('cabecalho.eMerkatorCast'),
          `/${lang}/#${t('slugs.eMerkator')}`
        ),
        menuItem(
          t('cabecalho.eMerkatorPush'),
          `/${lang}/#${t('slugs.eMerkator')}`
        ),
      ]),
      menuItem(t('cabecalho.imprensa'), `/${lang}#${t('slugs.imprensa')}`, [
        menuItem(t('cabecalho.noticias'), `/${lang}/${t('slugs.noticias')}`),
        menuItem(
          t('cabecalho.galeriaDeImagens'),
          `/${lang}/${t('slugs.galeriaDeImagens')}`
        ),
      ]),
      menuItem(
        t('cabecalho.contato'),
        'https://merkatorfeiras.com.br/pt#contato',
        [],
        true
      ),
    ];

    return myMenu;
  }, [t, lang]);

  return <CabecalhoShared medias={medias} menu={menu} logo={logoImage} />;
};

export default Cabecalho;
